// This file was automatically generated from render.messageThreadContent.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.messageThreadContent');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.messageThreadContent.message = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8Message ebs-row"><div class="el8MessageTime">', (soy.$$escapeHtml(opt_data.sendDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.sendDate)) : ''), '</div><div class="el8MessageText ');
  el8.template.render.messageThreadContent.messageClass(opt_data, output);
  output.append('"><p date="', (soy.$$escapeHtml(opt_data.sendDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.sendDate)) : ''), '" class="el8NoPadding el8ResponseAuthor ');
  el8.template.render.messageThreadContent.messageClass(opt_data, output);
  output.append('">', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.senderName)) : soy.$$escapeHtml(opt_data.senderName)), '</p><p class="el8Preserve">', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.body)) : soy.$$escapeHtml(opt_data.body)), '</p>', (opt_data.docId) ? '<p class="el8AppText el8SingleLineText">RE: <a class="item-details-trigger" data-id="' + soy.$$escapeHtml(opt_data.docId) + '">' + opt_data.docSummary + '</a></p>' : (opt_data.docPlaceholder) ? '<p class="el8AppText el8SingleLineText">RE: ' + soy.$$escapeHtml(opt_data.docPlaceholder) + '</p>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.messageThreadContent.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8AppColor">Message between: ');
  var memberList29417 = opt_data.members;
  var memberListLen29417 = memberList29417.length;
  for (var memberIndex29417 = 0; memberIndex29417 < memberListLen29417; memberIndex29417++) {
    var memberData29417 = memberList29417[memberIndex29417];
    output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(memberData29417.name)) : soy.$$escapeHtml(memberData29417.name)), (! (memberIndex29417 == memberListLen29417 - 1)) ? ', ' : '');
  }
  output.append('</p>');
  var messageList29425 = opt_data.messages;
  var messageListLen29425 = messageList29425.length;
  for (var messageIndex29425 = 0; messageIndex29425 < messageListLen29425; messageIndex29425++) {
    var messageData29425 = messageList29425[messageIndex29425];
    el8.template.render.messageThreadContent.message(messageData29425, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.messageThreadContent.messageClass = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isPhysician) ? 'el8PhysicianText' : 'el8StaffText');
  if (!opt_sb) return output.toString();
};
